// @ts-nocheck
import moment from 'moment';
import {
  BorderStyle,
  Document,
  Footer,
  Packer,
  Paragraph,
  Table,
  TableCell,
  TableRow,
  TextRun,
  VerticalAlign,
  WidthType,
} from 'docx';
import { saveAs } from 'file-saver';

import {
  clausula,
  clausula2,
  clausula3,
  clausula4,
  clausula5,
  clausula6,
  imageLogo,
  paragrafo4,
  paragrafo5,
  paragrafo6,
  paragrafoAcompanhamento,
  paragrafoAtividade,
  paragrafoCaso,
  paragrafoDuracao,
  paragrafoEstagiario,
  paragrafoEstagio,
  paragrafoLetras,
  paragrafoParticipante,
  paragrafoPresente,
  paragrafoPrimeiro,
  paragrafoPrimeiro1,
  paragrafoPrimeiro10,
  paragrafoPrimeiro11,
  paragrafoPrimeiro12,
  paragrafoPrimeiro13,
  paragrafoPrimeiro2,
  paragrafoPrimeiro3,
  paragrafoPrimeiro4,
  paragrafoPrimeiro5,
  paragrafoPrimeiro6,
  paragrafoPrimeiro7,
  paragrafoPrimeiro8,
  paragrafoPrimeiro9,
  paragrafoSegundo,
  paragrafoUnico,
  paragrafoUnico2,
  paragrafoVazio,
  presenteObjeto,
  representante,
  subTituloConcedente,
  subTituloEstagiario,
  subTituloInstituicao,
  termoCompromisso,
  tituloCarregadoEstagio,
  tituloPrincipal,
  tituloRodape,
  tituloSubdefensor,
} from './paragraph';
import { footerDoc } from './footerDoc';
import { tabelaDiasEHorarios } from './tableDoc';

import { DataAmigavel } from '@/shared/utils/datas';
import { Estagiario } from '@/modules/people/estagiario/domain/estagiario.dto';

export const exportToDoc = (data: Estagiario, estagio: EstagioDto) => {
  function nameString(str: string) {
    return str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
  }

  function getCellBorders() {
    return {
      top: { style: BorderStyle.SINGLE, size: 1 },
      bottom: { style: BorderStyle.SINGLE, size: 1 },
      left: { style: BorderStyle.SINGLE, size: 1 },
      right: { style: BorderStyle.SINGLE, size: 1 },
    };
  }

  const tableConcedente = new Table({
    alignment: 'center',
    width: { size: 100, type: WidthType.PERCENTAGE }, // Garantir 100% da largura
    rows: [
      new TableRow({
        children: [
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({ text: 'Razão Social:', bold: true }),
                  new TextRun({
                    text: ' DEFENSORIA PÚBLICA DO ESTADO DE SERGIPE - DPE/SE',
                  }),
                ],
              }),
            ],
            borders: getCellBorders(),
            width: { size: 100, type: WidthType.PERCENTAGE }, // 100% da largura na célula
            padding: { top: 0, right: 10, bottom: 10, left: 10 },
            alignment: 'center',
          }),
        ],
      }),
      new TableRow({
        children: [
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({ text: 'Endereço:', bold: true }),
                  new TextRun({
                    text: ' Travessa João Francisco da Silveira, n.º 44, Centro, CEP: 49.015-360, Aracaju/SE',
                  }),
                ],
              }),
            ],
            borders: getCellBorders(),
            width: { size: 100, type: WidthType.PERCENTAGE }, // Ajustado para ocupar 100% da largura total
            padding: { top: 0, right: 10, bottom: 10, left: 10 },
            alignment: 'center',
          }),
        ],
      }),
      new TableRow({
        children: [
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({ text: 'CNPJ:', bold: true }),
                  new TextRun({
                    text: ' 34.849.965/0001-75',
                  }),
                ],
              }),
            ],
            borders: getCellBorders(),
            width: { size: 100, type: WidthType.PERCENTAGE },
            padding: { top: 0, right: 10, bottom: 10, left: 10 },
            alignment: 'center',
          }),
        ],
      }),
    ],
    margins: { top: 100, bottom: 200 },
  });

  const tableInstituicao = new Table({
    alignment: 'center',
    width: { size: 100, type: WidthType.PERCENTAGE },
    rows: [
      new TableRow({
        children: [
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({ text: 'Razão Social:', bold: true }),
                  new TextRun({ text: ' XXXX', color: 'FF0000' }),
                ],
              }),
            ],
          }),
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({ text: 'Endereço:', bold: true }),
                  new TextRun({ text: ' XXXX', color: 'FF0000' }),
                ],
              }),
            ],
          }),
        ],
      }),
      new TableRow({
        children: [
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({ text: 'CNPJ:', bold: true }),
                  new TextRun({ text: ' XXXX', color: 'FF0000' }),
                ],
              }),
            ],
          }),
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({ text: 'Telefone:', bold: true }),
                  new TextRun({ text: ' XXXX', color: 'FF0000' }),
                ],
              }),
            ],
          }),
        ],
      }),
      new TableRow({
        children: [
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({ text: 'Representante:', bold: true }),
                  new TextRun({ text: ' XXXX', color: 'FF0000' }),
                ],
              }),
            ],
          }),
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({ text: 'Cargo:', bold: true }),
                  new TextRun({ text: ' XXXX', color: 'FF0000' }),
                ],
              }),
            ],
          }),
        ],
      }),
    ],
  });

  const tableDivisao = new Table({
    alignment: 'center',
    width: { size: 100, type: WidthType.PERCENTAGE }, // Garantir 100% da largura
    rows: [
      new TableRow({
        children: [
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({ text: 'Email:', bold: true }),
                  new TextRun({
                    text: ' Subdefensoria.',
                  }),
                ],
              }),
            ],
            padding: { top: 0, right: 10, bottom: 30, left: 10 },
            borders: getCellBorders(),
            width: { size: 100, type: WidthType.PERCENTAGE }, // Ajustado para ocupar 100% da largura total
            layout: 'fixed',
          }),
        ],
      }),
      new TableRow({
        children: [
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({ text: 'Telefone:', bold: true }),
                  new TextRun({
                    text: ' 3205-3800',
                  }),
                ],
              }),
            ],
            borders: getCellBorders(),
            width: { size: 750, type: WidthType.PERCENTAGE },
            layout: 'fixed',
          }),
        ],
      }),
    ],
    margins: { top: 100, bottom: 100 },
  });

  const tableCargo = new Table({
    alignment: 'center',
    width: { size: 100, type: WidthType.PERCENTAGE }, // Garantir 100% da largura
    rows: [
      new TableRow({
        children: [
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: 'Representante:',
                    bold: true,
                    color: 'FF0000',
                  }),
                  new TextRun({
                    text: ' Jesus Jairo Almeida de Lacerda',
                    color: 'FF0000',
                  }),
                ],
              }),
            ],
            borders: getCellBorders(),
            width: { size: 50, type: WidthType.PERCENTAGE }, // 50% da largura total
            padding: { top: 0, right: 5, bottom: 5, left: 5 }, // Padding mínimo
            alignment: 'center',
          }),
        ],
      }),
      new TableRow({
        children: [
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({ text: 'Cargo:', bold: true, color: 'FF0000' }),
                  new TextRun({
                    text: ' Subdefensor Público-Geral',
                    color: 'FF0000',
                  }),
                ],
              }),
            ],
            borders: getCellBorders(),
            width: { size: 50, type: WidthType.PERCENTAGE }, // 50% da largura total
            padding: { top: 0, right: 5, bottom: 5, left: 5 }, // Padding mínimo
            alignment: 'center',
          }),
        ],
      }),
    ],
    margins: { top: 100, bottom: 100 }, // Remover margens adicionais
  });

  const table = new Table({
    alignment: 'center',
    rows: [
      new TableRow({
        children: [
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({ text: 'Nome:', bold: true }),
                  new TextRun({
                    text: ` ${nameString(data.nome)}`,
                  }),
                ],
              }),
            ],
            borders: getCellBorders(),
            width: { size: 2500, type: WidthType.PERCENTAGE }, // Aumenta a largura da coluna "Nome"
            padding: { top: 0, right: 10, bottom: 10, left: 10 },
            alignment: 'center',
          }),
          // Coluna Email, ajustada para manter o espaço proporcional
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({ text: 'Responsável:', bold: true }),
                  new TextRun({
                    text: ' XXXX',
                    color: 'FF0000',
                  }),
                ],
              }),
            ],
            borders: getCellBorders(),
            width: { size: 750, type: WidthType.PERCENTAGE },
            padding: { top: 0, right: 10, bottom: 10, left: 10 },
            alignment: 'center',
          }),
        ],
      }),

      new TableRow({
        children: [
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({ text: 'Cpf:', bold: true }),
                  new TextRun({
                    text: ` ${data.cpf}`,
                  }),
                ],
              }),
            ],

            borders: getCellBorders(),
            width: { size: 1250, type: WidthType.PERCENTAGE },
            padding: { top: 0, right: 10, bottom: 10, left: 10 },
            alignment: 'center',
          }),
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({ text: 'Data Nascimento:', bold: true }),
                  new TextRun({
                    text: ` ${DataAmigavel(data.data_nascimento)}`,
                  }),
                ],
              }),
            ],

            borders: getCellBorders(),
            width: { size: 1250, type: WidthType.PERCENTAGE },
            padding: { top: 0, right: 10, bottom: 10, left: 10 },
            alignment: 'center',
          }),
        ],
      }),
      new TableRow({
        children: [
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({ text: 'Telefone:', bold: true }),
                  new TextRun({
                    text: ' XXXX',
                    color: 'FF0000',
                  }),
                ],
              }),
            ],

            borders: getCellBorders(),
            width: { size: 1250, type: WidthType.PERCENTAGE },
            padding: { top: 0, right: 10, bottom: 10, left: 10 },
            alignment: 'center',
          }),
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({ text: 'Endereço:', bold: true }),
                  new TextRun({
                    text: ' XXXX',
                    color: 'FF0000',
                  }),
                ],
              }),
            ],

            borders: getCellBorders(),
            width: { size: 1250, type: WidthType.PERCENTAGE },
            padding: { top: 0, right: 10, bottom: 10, left: 10 },
            alignment: 'center',
          }),
        ],
      }),
      new TableRow({
        children: [
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({ text: 'Curso:', bold: true }),
                  new TextRun({
                    text: ` ${estagio?.curso?.nome || ''}`,
                    color: 'FF0000',
                  }),
                ],
              }),
            ],

            borders: getCellBorders(),
            width: { size: 1250, type: WidthType.PERCENTAGE },
            padding: { top: 0, right: 10, bottom: 10, left: 10 },
            alignment: 'center',
          }),
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({ text: 'Matrícula:', bold: true }),
                  new TextRun({
                    text: ' XXXX',
                    color: 'FF0000',
                  }),
                ],
              }),
            ],

            borders: getCellBorders(),
            width: { size: 1250, type: WidthType.PERCENTAGE },
            padding: { top: 0, right: 10, bottom: 10, left: 10 },
            alignment: 'center',
          }),
        ],
      }),
      new TableRow({
        children: [
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({ text: 'Período:', bold: true }),
                  new TextRun({
                    text: `${DataAmigavel(estagio?.data_inicio_estagio)} até ${DataAmigavel(estagio?.data_fim_estagio || null)}`,
                    color: 'FF0000',
                  }),
                ],
              }),
            ],

            borders: getCellBorders(),
            width: { size: 1250, type: WidthType.PERCENTAGE },
            padding: { top: 0, right: 10, bottom: 10, left: 10 },
            alignment: 'center',
          }),
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({ text: 'Campus do Aluno:', bold: true }),
                  new TextRun({
                    text: ' XXXX',
                    color: 'FF0000',
                  }),
                ],
              }),
            ],

            borders: getCellBorders(),
            width: { size: 1250, type: WidthType.PERCENTAGE },
            padding: { top: 0, right: 10, bottom: 10, left: 10 },
            alignment: 'center',
          }),
        ],
      }),
      new TableRow({
        children: [
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({ text: 'Duração do Estágio:', bold: true }),
                  new TextRun({
                    text: ' XXXX',
                    color: 'FF0000',
                  }),
                ],
              }),
            ],

            borders: getCellBorders(),
            width: { size: 1250, type: WidthType.PERCENTAGE },
            padding: { top: 0, right: 10, bottom: 10, left: 10 },
            alignment: 'center',
          }),
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({ text: 'Lotação:', bold: true }),
                  new TextRun({
                    text: ' XXXX',
                    color: 'FF0000',
                  }),
                ],
              }),
            ],

            borders: getCellBorders(),
            width: { size: 1250, type: WidthType.PERCENTAGE },
            padding: { top: 0, right: 10, bottom: 10, left: 10 },
            alignment: 'center',
          }),
        ],
      }),
      new TableRow({
        children: [
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: 'Número da Apólice de Seguro:',
                    bold: true,
                  }),
                  new TextRun({
                    text: ' XXXX',
                    color: 'FF0000',
                  }),
                ],
              }),
            ],

            borders: getCellBorders(),
            width: { size: 1250, type: WidthType.PERCENTAGE },
            padding: { top: 0, right: 10, bottom: 10, left: 10 },
            alignment: 'center',
          }),
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({ text: 'Seguradora:', bold: true }),
                  new TextRun({
                    text: ' XXXX',
                    color: 'FF0000',
                  }),
                ],
              }),
            ],

            borders: getCellBorders(),
            width: { size: 1250, type: WidthType.PERCENTAGE },
            padding: { top: 0, right: 10, bottom: 10, left: 10 },
            alignment: 'center',
          }),
        ],
      }),
    ],
  });

  const tableDiasEHorarios = new Table({
    alignment: 'center',
    spacing: { before: 310 },
    rows: [
      new TableRow({
        children: [
          new TableCell({
            rowSpan: 2,
            children: [
              new Paragraph({
                children: [
                  new TextRun({ text: 'CARGA HORÁRIA', bold: true }),
                  new TextRun({ text: '\n', bold: true }),
                  new TextRun({ text: ' ' }),
                ],
                alignment: 'center',
              }),
            ],
            borders: getCellBorders(),
            verticalAlign: VerticalAlign.CENTER,
            margins: { top: 200, bottom: 200, left: 200, right: 200 },
            width: { size: 10, type: WidthType.PERCENTAGE },
          }),
          // Dias da semana
          new TableCell({
            children: [
              new Paragraph({
                children: [new TextRun({ text: 'Segunda-feira', bold: true })],
              }),
            ],
            borders: getCellBorders(),
            margins: { top: 200, bottom: 200, left: 200, right: 200 },
          }),
          new TableCell({
            children: [
              new Paragraph({
                children: [new TextRun({ text: 'Terça-feira', bold: true })],
              }),
            ],
            borders: getCellBorders(),
            margins: { top: 200, bottom: 200, left: 200, right: 200 },
          }),
          new TableCell({
            children: [
              new Paragraph({
                children: [new TextRun({ text: 'Quarta-feira', bold: true })],
              }),
            ],
            borders: getCellBorders(),
            margins: { top: 200, bottom: 200, left: 200, right: 200 },
          }),
          new TableCell({
            children: [
              new Paragraph({
                children: [new TextRun({ text: 'Quinta-feira', bold: true })],
              }),
            ],
            borders: getCellBorders(),
            margins: { top: 200, bottom: 200, left: 200, right: 200 },
          }),
          new TableCell({
            children: [
              new Paragraph({
                children: [new TextRun({ text: 'Sexta-feira', bold: true })],
              }),
            ],
            borders: getCellBorders(),
            margins: { top: 200, bottom: 200, left: 200, right: 200 },
          }),
        ],
      }),
      // Segunda linha - Horários
      new TableRow({
        children: [
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({ text: '13h às 17h', color: 'FF0000' }),
                ],
                alignment: 'center',
              }),
            ],
            borders: getCellBorders(),
            margins: { top: 200, bottom: 200, left: 200, right: 200 },
          }),
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({ text: '13h às 17h', color: 'FF0000' }),
                ],
                alignment: 'center',
              }),
            ],
            borders: getCellBorders(),
            margins: { top: 200, bottom: 200, left: 200, right: 200 },
          }),
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({ text: '13h às 17h', color: 'FF0000' }),
                ],
                alignment: 'center',
              }),
            ],
            borders: getCellBorders(),
            margins: { top: 200, bottom: 200, left: 200, right: 200 },
          }),
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({ text: '13h às 17h', color: 'FF0000' }),
                ],
                alignment: 'center',
              }),
            ],
            borders: getCellBorders(),
            margins: { top: 200, bottom: 200, left: 200, right: 200 },
          }),
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({ text: '13h às 17h', color: 'FF0000' }),
                ],
                alignment: 'center',
              }),
            ],
            borders: getCellBorders(),
            margins: { top: 200, bottom: 200, left: 200, right: 200 },
          }),
        ],
      }),
    ],
    margins: { top: 200, bottom: 200, left: 200, right: 200 },
  });

  const doc = new Document({
    background: {
      color: 'FFFFFF', // Defina a cor de fundo no formato hexadecimal
    },
    sections: [
      {
        properties: {},
        children: [
          tituloPrincipal(),
          subTituloConcedente(),
          tableConcedente,
          tableDivisao,
          tableCargo,
          subTituloInstituicao(),
          tableInstituicao,
          subTituloEstagiario(),
          table,
          paragrafoVazio(),
          termoCompromisso(),
          paragrafoVazio(),
          clausula(),
          paragrafoVazio(),
          presenteObjeto(),
          paragrafoVazio(),
          paragrafoPrimeiro(),
          paragrafoSegundo(),
          paragrafoAcompanhamento(),
          clausula2(),
          paragrafoDuracao(),
          clausula3(),
          paragrafoAtividade(),
          tableDiasEHorarios,
          // tabelaDiasEHorarios(),
          paragrafoUnico(),
          paragrafo4(),
          paragrafoEstagio(),
          paragrafo5(),
          paragrafoCaso(),
          paragrafoUnico2(),
          paragrafo6(),
          paragrafoPrimeiro1(),
          paragrafoPrimeiro2(),
          paragrafoPrimeiro3(),
          paragrafoPrimeiro4(),
          clausula4(),
          paragrafoPresente(),
          paragrafoLetras(),
          clausula5(),
          paragrafoEstagiario(),
          clausula6(),
          paragrafoParticipante(),
          paragrafoPrimeiro5(),
          paragrafoPrimeiro6(),
          paragrafoPrimeiro7(),
          paragrafoPrimeiro8(),
          paragrafoPrimeiro9(),
          paragrafoPrimeiro10(),
          paragrafoPrimeiro11(),
          paragrafoPrimeiro12(),
          paragrafoPrimeiro13(),
          tituloSubdefensor(),
          tituloCarregadoEstagio(),
          tituloRodape(),
        ],
        headers: {
          default: imageLogo(),
        },
        footers: {
          default: footerDoc(),
        },
      },
    ],
  });

  Packer.toBlob(doc).then((blob) => {
    saveAs(blob, 'Estagiario.docx');
  });
};
